<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{props ? `${$t("modal.station_config.speaker.edit")} ${props.name}` : $t("modal.station_config.speaker.create")}}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>
      
      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="code" id="code" autocomplete="off" :class="{'invalid': submitted && v$.model.code.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.speaker.code')" v-model="model.code" maxLength="25">
          <label for="code">{{$t("modal.station_config.speaker.code")}} 
            <small v-if="submitted && v$.model.code.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="name" id="name" autocomplete="off" :class="{'invalid': submitted && v$.model.name.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.speaker.name')" v-model="model.name" maxLength="250">
          <label for="name">{{$t("modal.station_config.speaker.name")}} 
            <small v-if="submitted && v$.model.name.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>
    
      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ props ? $t("modal.save") : $t('modal.create') }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && v$.model.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.model.$silentErrors.map(error => $t(`modal.station_config.speaker.${error.$property}`)).join(', ') })"></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { maxLength, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

export default {
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    const submitted = ref(false);
    const model = ref({
      code: '',
      name: ''
    })

    onMounted(() => {
      if (props.value) model.value = Object.assign({}, props.value);
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    async function saveAndClose() {
      submitted.value = true;
      if (!v$.value.model.$invalid) {
        try {
          await store.dispatch(props.value ? 'speaker_update' : 'speaker_create', model.value);
          this.closeModal();
        } catch (error) {
          console.error(error);
        }
      }
    }

    return {
      v$,
      props,
      model,
      submitted,
      saveAndClose,
      closeModal
    }
  },
	validations () {
    return {
      model: {
				code: {required, maxLengthValue: maxLength(25)},
				name: {required, maxLengthValue: maxLength(250)}
			}
    }
  }
};
</script>